// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";
// @ts-ignore
import { PermissionLevel } from "./permission_level";

export class SetIdentityPermissionReducer extends Reducer
{
	public static reducerName: string = "SetIdentityPermission";
	public static call(_identity: Identity, _permissionLevel: PermissionLevel) {
		this.getReducer().call(_identity, _permissionLevel);
	}

	public call(_identity: Identity, _permissionLevel: PermissionLevel) {
		const serializer = this.client.getSerializer();
		let _identityType = AlgebraicType.createProductType([
			new ProductTypeElement("__identity_bytes", AlgebraicType.createArrayType(AlgebraicType.createPrimitiveType(BuiltinType.Type.U8))),
		]);
		serializer.write(_identityType, _identity);
		let _permissionLevelType = PermissionLevel.getAlgebraicType();
		serializer.write(_permissionLevelType, _permissionLevel);
		this.client.call("SetIdentityPermission", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let identityType = AlgebraicType.createProductType([
			new ProductTypeElement("__identity_bytes", AlgebraicType.createArrayType(AlgebraicType.createPrimitiveType(BuiltinType.Type.U8))),
		]);
		let identityValue = AlgebraicValue.deserialize(identityType, adapter.next())
		let identity = new Identity(identityValue.asProductValue().elements[0].asBytes());
		let permissionLevelType = PermissionLevel.getAlgebraicType();
		let permissionLevelValue = AlgebraicValue.deserialize(permissionLevelType, adapter.next())
		let permissionLevel = PermissionLevel.fromValue(permissionLevelValue);
		return [identity, permissionLevel];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _identity: Identity, _permissionLevel: PermissionLevel) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _identity: Identity, _permissionLevel: PermissionLevel) => void)
	{
		this.client.on("reducer:SetIdentityPermission", callback);
	}
}


export default SetIdentityPermissionReducer
